<div class="p-text-center payment-failed-title">
  {{'payment.response.order.number' | translate: { orderNumber: orderNumber } }}
</div>
<div class="payment-mascot-center">
  <img class="mascot" src="assets/mascot/Mascot_sad-Grey@2x.webp" alt="odaring mascot"/>
  <p>{{ 'payment.failed.content.msg' | translate }}</p>
</div>
